import { animate, AnimationTriggerMetadata, group, query, state, style, transition, trigger } from '@angular/animations';


export const fadeInAnimation: AnimationTriggerMetadata =
    trigger('fadeInAnimation', [
        state(':enter', style({opacity: 0})),
        transition(':enter', [
            style({opacity: 0}),
            animate('{{time}} {{delay}}', style({ opacity: 1 }))
        ], {params: {time: '300ms', delay: '0ms'}}),
        transition(':leave', [
            animate('{{timeLeave}} {{delayLeave}}', style({ opacity: 0 }))
        ], {params: {timeLeave: '300ms', delayLeave: '0ms'}})
    ]);

export const fadeInAnimationB: AnimationTriggerMetadata =
    trigger('fadeInAnimation', [
        state(':enter', style({opacity: 0})),
        transition('* => active', [
            style({opacity: 0}),
            animate('{{time}} {{delay}}', style({ opacity: 1 }))
        ], {params: {time: '300ms', delay: '0ms'}}),
        transition('active => *', [
            animate('{{timeLeave}} {{delayLeave}}', style({ opacity: 0 }))
        ], {params: {timeLeave: '300ms', delayLeave: '0ms'}})
    ]);
